// Key the menu reports to Toolbar.Root; the picked item follows it.
export const AI_MENU_ID = 'ai'

export const GENERATE_ID = 'generate'
export const CHANGE_COLORS_ID = 'change_colors'
export const TRANSLATE_ID = 'translate'
export const ASSISTANT_ID = 'assistant'
export const SEO_TAGS_ID = 'seo_tags'
// The locked Change colors item sells the plan instead of opening the prompt.
export const UPGRADE_ID = 'upgrade'
// Change colors and Translate open in place of the list; Back returns to it.
export const BACK_ID = 'back'

export type AiMenuView = 'colors' | 'list' | 'translate'

export const DOCS_URL = '/docs'

export const COLOR_PLACEHOLDERS = [
  'Try #662E9B, #43BCCD, #EA3546 and #F9C80E',
  'Try Google brand colors',
  'Try vivid summer colors',
  'Try different tones of blue',
  'Try black & white tones',
]

export {
  LANGUAGES,
  type TranslationLanguage,
} from '../../hooks'
